import { jsx as d } from "react/jsx-runtime";
import R from "../../../ui-kit/theme-button.mjs";
import { useStore as b } from "../../../store/index.mjs";
import { offerDefaultErrors as h } from "../../../pages/checkout/constants/default-errors.mjs";
import { BadRequest as w } from "@systemeio/util";
import { razorpayBuyOffer as B } from "../api/razorpay-api.mjs";
import D from "../hooks/useRazorpay.mjs";
function C({
  isFetching: t,
  buttonTitle: e,
  buttonDisabled: a,
  setErrors: n,
  setIsFetching: o,
  handleBadRequest: i,
  preSubmit: s
}) {
  const { locale: p } = b(), { generateOptions: f, isRazorpayReady: m, Razorpay: u, isRazorpayFetching: y } = D();
  return /* @__PURE__ */ d(
    R,
    {
      disabled: a,
      type: "submit",
      onClick: async (c) => {
        c.preventDefault(), o(!0), n(h);
        try {
          const r = s();
          if (!r) return;
          const l = await B(r, p), z = f(l);
          if (m)
            new u(z).open();
          else
            throw new Error("form submitted before razorpay was ready");
        } catch (r) {
          if (r instanceof w)
            i(r);
          else
            throw r;
        } finally {
          o(!1);
        }
      },
      isFetching: t || y,
      children: e
    }
  );
}
export {
  C as RazorpayPaymentButton
};
